<div *ngIf="isInputFormOpen">
   <div id = "mainBlackBg" class="main" (click)="openCloseInputFormClick($event)">
      <div class="input-box box-size" [ngClass]="{'box-with-error' : isErrorMessage}">
         <div class="title-type">
            <p>
               {{ 'lbl_' + titleRelationshipOf | lowercase | translate}} {{ 'lbl_of' | translate }} {{titleMainPerson}} <span *ngIf="titleAndPartnerShow">{{ 'lbl_and' | translate }} {{titleAndPartner}}</span></p>
               
         </div>
         <form #submitForm="ngForm">
            <div *ngIf="isErrorMessage" class="box-overlay"></div>
            <div class="name-label box-size {{selectedMemberData.Gender}}Color"
               [ngClass]="{'FBackground-Error': selectedMemberData.Gender == 'F' && isErrorMessage, 'MBackground-Error': selectedMemberData.Gender == 'M' && isErrorMessage}">
               {{ 'lbl_' + selectedMemberData.RelationShipType | lowercase | translate}}
            </div>
            <input id="name" class="name-input {{selectedMemberData.Gender}}TextColor" name="name" #name="ngModel"
               autocomplete="off" [(ngModel)]="individualName" (keyup.enter)="submitInputName();"
               placeholder="Fornavn Etternavn" [ngClass]="{'inputbox-error': isErrorMessage}"
               [ngClass]="{'FFiled-Error': selectedMemberData.Gender == 'F' && isErrorMessage, 'MFiled-Error': selectedMemberData.Gender == 'M' && isErrorMessage}">
            <img class="btn-form element-over-hand" src="../../../../../assets/input-form/{{okayButton}}"
               (click)="submitInputName()" />
            <img class="btn-form element-over-hand" src="../../../../../assets/input-form/{{closeButton}}"
               (click)="openCloseInputForm()" />
         </form>
         <div class="error-box box-size box-animation" [class.opened]="isErrorMessage">
            <div class="error-message">
               {{ errorMessage | translate }}
            </div>
            <div class="btn-error">
               <img class="btn-form element-over-hand" src="../../../../../assets/input-form/btn-ok.png"
                  (click)="closeErrorBox()" />
            </div>
         </div>
      </div>
   </div>
</div>
